import { ReactElement, Suspense } from 'react';
import PageLayout from '../../components/PageLayout';
import MainContent from '../../components/MainContent';
import SideBar from '../../components/SideBar';
import Header from './components/Header';
import Loading from '../../components/Loading';
import Content from './components/Content';

const UploadRecordingPage = (): ReactElement => (
  <PageLayout
    sidebar={<SideBar />}
    mainContent={
      <MainContent
        header={<Header />}
        content={
          <Suspense fallback={<Loading />}>
            <Content />
          </Suspense>
        }
      />
    }
  />
);

export default UploadRecordingPage;
